import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getManagers } from '../../api/managerService';

export default function Directorates() {
  const navigate = useNavigate();
  const [directorates, setDirectorates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDirectorates = async () => {
      try {
        const response = await getManagers();
        console.log('Müdürler Listesi Response:', response);
        if (response.isSuccess && response.data) {
          setDirectorates(response.data);
        } else {
          setError(response.resultMessage || 'Müdürlük bilgileri yüklenirken bir hata oluştu.');
        }
        setLoading(false);
      } catch (err) {
        console.error('Müdürler Listesi Error:', err);
        setError('Müdürlük bilgileri yüklenirken bir hata oluştu.');
        setLoading(false);
      }
    };

    fetchDirectorates();
  }, []);

  const handleDirectorateClick = (guid) => {
    navigate(`/mudurlukler/${guid}`, { replace: true });
  };

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Yükleniyor... | İskenderun Belediyesi</title>
        </Helmet>
        <div className="directorates-page">
          <div className="container-fluid py-5">
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Helmet>
          <title>Hata | İskenderun Belediyesi</title>
        </Helmet>
        <div className="directorates-page">
          <div className="container-fluid py-5">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Müdürlerimiz | İskenderun Belediyesi</title>
        <meta name="description" content="İskenderun Belediyesi müdürlükleri ve yöneticileri hakkında detaylı bilgi." />
      </Helmet>
      <div className="directorates-page">
        <div className="container-fluid py-5">
          <div className="directorates-page-title">
            <h1>Müdürlerimiz</h1>
          </div>
          <div className="directorates-boxes row">
            {directorates.map((director) => (
           
                <div className="col-lg-6">
                <div className="directorates-box">
                  <div className="directorates-box_left">
                    <img src={director.pictureUrl} alt={`${director.name} - ${director.positionName}`} />
                  </div>
                  <div className="directorates-box_right">
                    <div className="directorates-title">
                      <h2>{director.name}</h2>
                      <span>{director.positionName}</span>
                    </div>
                    {director.dutyAndResponsibility && (
                    <>
                    <div className="directorates-work">
                      <span>Görev ve Sorumluluklar</span>
                    </div>
                    <p className="directorates-description">
                    {director.dutyAndResponsibility}
                  </p>
                    </>
                    )}
               
                    {/* <div className="directorates-button">
                      <button 
                        className='directorates-button-btn'
                        onClick={() => handleDirectorateClick(director.guid)}
                      >
                        Daha Fazla Gör
                      </button>
                    </div> */}
                  </div>
                </div>
                </div>
               
              
            ))}
          </div>
        </div>
      </div>
    </>
  );
}